import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './IconCircle.module.scss';

interface IconCircleProps {
    size?: number;
    icon: IconProp;
}

export const IconCircle: React.FC<IconCircleProps> = ({ icon, size = 24 }) => {
    return (
        <div
            className={classes.root}
            style={
                {
                    '--size': `${size}px`
                } as React.CSSProperties
            }
        >
            <FontAwesomeIcon icon={icon} />
        </div>
    );
};
